module.exports = __webpack_public_path__ + "images/goods-details-icon-home.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/goods-details-icon-home.png
// module id = 853
// module chunks = 126